import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';

export const getTextFieldStyle = () => ({
  '& label.Mui-focused': {
    color: greenColors[700],
  },
  '& .MuiOutlinedInput-root': {
    '&:hover': {
      backgroundColor: orangeColors[5],
    },
    '& fieldset': {
      borderColor: orangeColors[5],
    },
    '&:hover fieldset': {
      borderColor: orangeColors[3],
    },
    '&.Mui-focused': {
      backgroundColor: orangeColors[3],
    },
    '&.Mui-focused fieldset': {
      borderColor: orangeColors[3],
    },
    '& .MuiOutlinedInput-input': {
      caretColor: greenColors[700],
      color: greenColors[700],
    },
  },
});
